import type { GenericField } from '@Types';
// NOTE: This is used only to apply rules for the animal templates.
// The actual templates are fetched from the API.
enum CATEGORY {
  CAT = 'cat',
  DOG = 'dog',
  RABBIT = 'rabbit',
  HORSE = 'horse',
  WILDLIFE = 'wildlife',
  BARN = 'barn',
  BIRD = 'bird',
  POCKET = 'pocket',
  REPTILE = 'reptile',
  OTHER = 'other',
}

const CATEGORIES = <GenericField[]>[
  {
    name: 'Cat',
    value: CATEGORY.CAT,
  },
  {
    name: 'Dog',
    value: CATEGORY.DOG,
  },
  {
    name: 'Rabbit',
    value: CATEGORY.RABBIT,
  },
  {
    name: 'Horse',
    value: CATEGORY.HORSE,
  },
  {
    name: 'Wildlife',
    value: CATEGORY.WILDLIFE,
  },
  {
    name: 'Barn',
    value: CATEGORY.BARN,
  },
  {
    name: 'Bird',
    value: CATEGORY.BIRD,
  },
  {
    name: 'Pocket',
    value: CATEGORY.POCKET,
  },
  {
    name: 'Reptile',
    value: CATEGORY.REPTILE,
  },
  {
    name: 'Other',
    value: CATEGORY.OTHER,
  },
];
const CATEGORIES_WITHOUT_SPECIES = [CATEGORY.DOG, CATEGORY.CAT, CATEGORY.RABBIT];
const CATEGORIES_WITHOUT_MICROCHIPS = [CATEGORY.WILDLIFE, CATEGORY.POCKET, CATEGORY.REPTILE];

export { CATEGORIES, CATEGORIES_WITHOUT_SPECIES, CATEGORIES_WITHOUT_MICROCHIPS, CATEGORY };
